var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2302 7.7625C15.1427 6.675 13.6502 6 11.9927 6C8.67774 6 6.00024 8.685 6.00024 12C6.00024 15.315 8.67774 18 11.9927 18C14.7902 18 17.1227 16.0875 17.7902 13.5H16.2302C15.6152 15.2475 13.9502 16.5 11.9927 16.5C9.51024 16.5 7.49274 14.4825 7.49274 12C7.49274 9.5175 9.51024 7.5 11.9927 7.5C13.2377 7.5 14.3477 8.0175 15.1577 8.835L12.7427 11.25H17.9927V6L16.2302 7.7625Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh_icon.86c8f431e75d0b3050ea333cb274e72b.svg";
export { ForwardRef as ReactComponent };